<div>
    @if (student) {
        <div class="gap-space-32 d-flex flex-column padding-32">
            <!-- CONFIRMATION DETAILS -->
            <div class="gap-space-16 d-flex flex-column">
                @if (isBookingWidget) {
                    <p class="typography-title-small" i18n="@@CommonBookingDetailsTitle">Booking Details</p>
                }
                @if (!isBookingWidget) {
                    <p class="typography-title-small" i18n="@@CommonRegistrationDetailsTitle">Registration Details</p>
                }
                <div class="scss-thank-you-student-detail">
                    <div class="d-flex align-items-center padding-y-16 padding-x-14" [ngClass]="{'flex-wrap gap-2': isMobile}">
                        <div [ngClass]="{'col-12': isMobile, 'col-6': !isMobile}">
                            <div class="d-flex gap-3">
                                <div class="rounded-circle d-flex align-items-center justify-content-center scss-sign-up-avatar background-brand" style="height: 36px; width: 36px;">
                                    {{student.FirstName! | method:GetInitial | uppercase}}
                                </div>
                                <div class="d-flex flex-column">
                                    <p class="typography-label-large-strong base-200">
                                        {{student.FirstName}} {{student.LastName}}
                                    </p>
                                    <div class="d-flex gap-2">
                                        <p class="typography-body-small neutral-800" i18n="@@CommonStudent">#Student#</p>
                                        <!-- eslint-disable-next-line -->
                                        <p class="typography-body-small neutral-800">•</p>
                                        @if (!student.IsAdult) {
                                            <p class="typography-body-small neutral-800" i18n="@@CommonStudentsAddStudentIsChildStudent">Child</p>
                                        }
                                        @if (student.IsAdult) {
                                            <p class="typography-body-small neutral-800" i18n="@@CommonSignUpWidgetPrimaryContactLabel">Primary Contact</p>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex row align-items-center" data-clarity-mask="true" [ngClass]="{'col-12': isMobile, 'col-6': !isMobile}">
                            @if (student.EmailAddress && !student.IsAdult) {
                                <lib-icon-bullet class="d-flex"
                                        [icon]="Icon.Common.MailOutline">
                                        {{student.EmailAddress}}
                                </lib-icon-bullet>
                            }
                            @if (student.IsAdult) {
                                <div>
                                    <ng-container *ngTemplateOutlet="parentPhoneNumbers; context:{$implicit:parent}"></ng-container>
                                </div>
                            }
                        </div>
                    </div>
                    @if (data.RegistrationFeeAmount && data.PaymentType == SignupPaymentType.Fees) {
                        <div class="border-top padding-y-12 padding-x-16 d-flex justify-content-between">
                            <p class="typography-body-medium" i18n="@@CommonRegistrationFeeLabel">Registration Fee</p>
                            <p class="typography-body-medium">{{data.RegistrationFeeAmount | formatCurrency}}</p>
                        </div>
                    }
                    @if (data.PaymentType == SignupPaymentType.Deposit && data.DepositAmount) {
                        <div class="border-top padding-y-12 padding-x-16 d-flex justify-content-between">
                            <p class="typography-body-medium" i18n="@@CommonDepositLabel">Deposit</p>
                            <p class="typography-body-medium">{{data.DepositAmount | formatCurrency}}</p>
                        </div>
                    }
                </div>

                @if (student.BookingRequest) {
                    <div class="scss-thank-you-student-detail">
                        <div class="d-flex gap-1 flex-wrap padding-16">
                            <lib-status-label [kind]="StatusKind.Light" [icon]="Icon.Common.PersonVoiceOver">
                                <ng-container label>
                                    @if (student.BookingRequest.Teacher) {
                                    <span data-clarity-mask="true">{{student.BookingRequest.Teacher.Name}}</span>
                                    }
                                    @if (!student.BookingRequest.Teacher) {
                                    <ng-container i18n="@@CommonCalendarNoTeacherOption">General Event - No #Teacher# Specified</ng-container>
                                    }
                                </ng-container>
                            </lib-status-label>
                            <lib-status-label [kind]="StatusKind.Light" [icon]="Icon.Common.Calendar">
                                <ng-container label>
                                    {{student.BookingRequest.StartDate | formatDate: 'long'}}
                                </ng-container>
                            </lib-status-label>
                            <lib-status-label [kind]="StatusKind.Light" [icon]="Icon.Common.Time">
                                <ng-container label>
                                    {{student.BookingRequest.StartDate| formatTime: 'short'}} - {{student.BookingRequest.EndDate | formatTime: 'short'}}
                                </ng-container>
                            </lib-status-label>
                            <lib-status-label [kind]="StatusKind.Custom" [icon]="Icon.Common.LabelTag" [labelColor]="student.BookingRequest.EventCategory!.Color| method: BackgroundColorClass">
                                <ng-container label>
                                    {{ student.BookingRequest.EventCategory!.Name }}
                                </ng-container>
                            </lib-status-label>
                            @if (student.BookingRequest.EventLocation; as location) {
                                <lib-status-label [kind]="StatusKind.Custom"
                                    [icon]="student.BookingRequest.EventLocation.Icon! | calendarEventLocationIcon" [labelColor]="student.BookingRequest.EventLocation.Color | method: BackgroundColorClass">
                                    <ng-container label>
                                        {{student.BookingRequest.EventLocation.Name}}
                                    </ng-container>
                                </lib-status-label>
                            }
                        </div>
                        @if (student.BookingRequest && data.PaymentType == SignupPaymentType.Fees && student.BookingRequest.EventPrice! > 0) {
                            <div class="border-top padding-y-12 padding-x-16 d-flex justify-content-between">
                                <p class="typography-body-medium" i18n="@@CommonLessonBookingPriceLabel">#Lesson# Booking Price</p>
                                <p class="typography-body-medium">{{student.BookingRequest.EventPrice! | formatCurrency}}</p>
                            </div>
                        }
                    </div>
                }
            </div>

            <!-- PAYMENT METHOD - CANT DO THIS -->
            <!-- <div class="gap-space-16 d-flex flex-column">
                <p class="typography-title-small" i18n="@@CommonPaymentMethodTitle">Payment Method</p>
                <div class="col-6 scss-thank-you-student-detail padding-16 gap-3">
                    <div class="d-flex justify-content-between">
                        <p class="typography-label-large-strong">
                            Card Type
                        </p>
                        <p class="typography-label-large-strong">
                            •••• 4148
                        </p>
                    </div>
                    <div class="d-flex justify-content-between align-items-center">
                        <p class="typography-body-small">Exp. Date</p>
                        <lib-icon *ngLet="(paymentDisplayItem | paymentIssuerIcon) as icon" [icon]="icon.Icon" [size]="IconSize.Large"></lib-icon>
                    </div>
                </div>
            </div> -->

            <!-- Summary -->
            @if (paymentSource) {
                <div class="gap-space-16 d-flex flex-column">
                    <p class="typography-title-small" i18n="@@CommonSummaryTitle">Summary</p>
                    <div class="scss-thank-you-student-detail">
                        @if (paymentSource.Surcharge! > 0) {
                            <div class="d-flex flex-column padding-x-16 padding-y-12 gap-space-12">
                                <div class="d-flex justify-content-between">
                                    <p class="typography-body-medium" i18n="@@CommonSubtotalLabel">Subtotal</p>
                                    <p class="typography-body-medium">{{(paymentSource.Total! - paymentSource.Surcharge!) | formatCurrency}}</p>
                                </div>
                                <!-- @if (data.RegistrationFeeAmount != null && data.PaymentType == SignupPaymentType.Fees && data.RegistrationFeeAmount > 0) {
                                    <div class="d-flex justify-content-between">
                                        <p class="typography-body-medium" i18n="@@CommonRegistrationFeeLabel">Registration Fee</p>
                                        <p class="typography-body-medium">{{data.RegistrationFeeAmount | formatCurrency}}</p>
                                    </div>
                                } -->
                                <div class="d-flex justify-content-between">
                                    <p class="typography-body-medium" i18n="@@CommonConvenienceFeeLabel">Convenience Fee</p>
                                    <p class="typography-body-medium">{{paymentSource.Surcharge! | formatCurrency}}</p>
                                </div>
                            </div>
                        }
                        <div class="padding-y-12 padding-x-16 d-flex justify-content-between" [ngClass]="{'border-top': paymentSource.Surcharge! > 0}">
                            <p class="typography-title-small" i18n="@@CommonTotalHeader">Total</p>
                            <p class="typography-title-small">{{paymentSource.Total ?? 0 | formatCurrency}}</p>
                        </div>
                    </div>
                </div>
            }
        </div>
        <mat-divider></mat-divider>
    }

    <lib-submission-bar
        [kind]="SubmissionBarKind.WidgetStepper">
        <lib-button
        [role]="ButtonRole.Primary"
            [kind]="ButtonKind.Primary"
            [loading]="submitButtonClicked"
            [size]="ButtonSize.Large"
            (clicked)="SubmitClicked()">
            <ng-container label>
                @if (((data.PaymentType == SignupPaymentType.Deposit && data.DepositAmount == 0) ||  (data.PaymentType == SignupPaymentType.Fees && student?.BookingRequest?.EventPrice! == 0))) {
                    <ng-container i18n="@@CommonConfirmButton">Confirm</ng-container>
                }
                @if (!((data.PaymentType == SignupPaymentType.Deposit && data.DepositAmount == 0) ||  (data.PaymentType == SignupPaymentType.Fees && student?.BookingRequest?.EventPrice! == 0))) {
                    <ng-container i18n="@@SUFDesignBlockConfirmPayButton">Confirm & Pay</ng-container>
                }
            </ng-container>
        </lib-button>
        <lib-button
        [role]="ButtonRole.Secondary"
            [kind]="ButtonKind.NeutralSecondary"
            [disabled]="submitButtonClicked"
            [size]="ButtonSize.Large"
            (clicked)="PreviousClicked()">
            <ng-container label i18n="@@CommonPreviousButton">Previous</ng-container>
        </lib-button>
        <ng-template #customAction>
            <p class="typography-label-large" i18n="@@CommonCurrentStepOfStepsLabel">{{currentStepIndex}} of {{totalStepCounts}}</p>
        </ng-template>

</lib-submission-bar>
</div>

<ng-template #parentPhoneNumbers let-parent>
    <div class="d-flex flex-column gap-2">
        @if (parent.EmailAddress) {
            <lib-icon-bullet class="d-flex" [icon]="Icon.Common.MailOutline">
                {{parent.EmailAddress}}
            </lib-icon-bullet>
        }
        @if (parent.TelephoneNumberHome) {
            <lib-icon-bullet class="d-flex" [icon]="Icon.Common.OldPhoneOutline">
                {{parent.TelephoneNumberHome}}
            </lib-icon-bullet>
        }
        @if (parent.TelephoneNumberMobile) {
            <lib-icon-bullet class="d-flex" [icon]="Icon.Common.PhoneAltOutline">
                {{parent.TelephoneNumberMobile}}
            </lib-icon-bullet>
        }
    </div>
</ng-template>